import { IDmLoaiBangTotNghiep } from "../../../model/response/category/IDmLoaiBangTotNghiep";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLoaiBangTotNghiepActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDmLoaiBangTotNghiep[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDmLoaiBangTotNghiep | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDmLoaiBangTotNghiep,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    SHOW_GAN_LOP_MODAL: {} as IDmLoaiBangTotNghiep | undefined,
    CLOSE_GAN_LOP_MODAL: undefined,

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eLoaiBangTotNghiepActionIds = generateActionTypeIds(eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP");
export type ILoaiBangTotNghiepActionTypes = IGenericActionType<typeof eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP">;
